export default function AboutMaker() {
  return <h1>AboutMaker</h1>;
}
